import React from 'react';
import NextGearHeroSection from './sections/hero/HeroSection';
import NextGearWhatIsSection from './sections/what-is/WhatIsSection';
import NextGearHowItWorks from './sections/how-it-works/HowItWorksSection';
import NextGearWhyUse from './sections/why-use/WhyUseSection';
import NextGearCardsSection from './sections/cards/CardsSection';
import NextGearContactUsSection from './sections/contact-us/ContactUsSection';

function NextGearCapitalPage() {
  return (
    <>
      <NextGearHeroSection />
      <NextGearWhatIsSection />
      <NextGearHowItWorks />
      <NextGearWhyUse />
      <NextGearCardsSection />
      <NextGearContactUsSection />
    </>
  );
}

export default NextGearCapitalPage;
